import React, { useEffect, useState } from "react";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import crossIcon from "../../assets/images/CrossInActive.svg";
import useRequireAuth from "../../utils/useRequireAuth";
import Checkbox from "../UniversalComponents/CheckBox";
import BasicSelect from "../Task/BasicSelect";
import HighlightedParagraph from "../UniversalComponents/HighlightedParagraph";
// import { useFetchGetCompanyListGroupsQuery } from "../../utils/customer/customerTaskTable";
// import { ReactComponent as DropDownArrow } from "../../assets/images/DropdownIcon.svg";
import { ReactComponent as DropDownArrow } from "../../assets/images/downArrow.svg";
import LoaderWrapper from "../UniversalComponents/CustomLoader";
import { useFetchCompanyListDataQuery } from "../../utils/customer/customerTaskTable";
import { HighlightTwoTone } from "@mui/icons-material";
import ToggleSwitch from "../UniversalComponents/ToggleSwitch";
import MotionSearchBox from "../UniversalComponents/MotionSearchBox";

const UserAccessDrawer = ({
  isPermissionOpen,
  setIsPermissionOpen,
  formData,
  setFormData,
  selectedGroup,
  setIsCompanyValid = () => null,
  subDrawer,
}) => {
  const [groupSearchTerm, setGroupSearchTerm] = useState("");
  const [companySearchTerm, setCompanySearchTerm] = useState("");
  // const [organization, setOrganization] = useState(selectedGroup || [])
  const [companyList, setCompanyList] = useState([]);

  const { token } = useRequireAuth();
  let userToken = token || JSON.parse(localStorage.getItem("myUserData")).token;

  const [viewOwnerDropDown, setViewOwnerDropDown] = useState(null);
  const [checkedState, setCheckedState] = useState({});
  const [isModuleVisible, setIsModuleVisible] = useState(true);

  const AccessLevelArray = [
    { label: "Owner", value: 1 },
    { label: "Contributor", value: 0 },
  ];

  console.log(selectedGroup, "helllloform");

  // useEffect(() => {
  //   if (companyCommnData) {
  //     setCompany(companyCommnData?.data);
  //   }
  // }, [companyCommnData, userToken]);

  //filter function
  const filterItems = (items, searchTerm, key) => {
    return items?.filter((item) => item[key]?.toLowerCase().includes(searchTerm?.toLowerCase()));
  };

  const filteredGroups = filterItems(selectedGroup, groupSearchTerm, "module_name");
  // const filteredCompanyList = filterItems(companyList, companySearchTerm, "company_name");

  // to filter out & bring the selected companies to the top of the list
  const sortedAndFilteredCompanyList = React.useMemo(() => {
    const filteredCompanyList = filterItems(companyList, companySearchTerm, "company_name");

    return filteredCompanyList?.sort((a, b) => {
      const aSelected = formData.company?.some((c) => c.company_id === a.company_id);
      const bSelected = formData.company?.some((c) => c.company_id === b.company_id);
      return (bSelected ? 1 : 0) - (aSelected ? 1 : 0);
    });
  }, [companyList, companySearchTerm]);

  const handleCheckboxChange = (companyName) => {
    setCheckedState((prev) => ({
      ...prev,
      [companyName]: !prev[companyName],
    }));
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // console.log(name, value, selectData, "helllovallluee");
  };

  // useEffect(() => {
  //   console.log(formData, "helllovallluee");
  // }, [formData]);

  // const fetchCompanyListData = async () => {
  //   const getCompanyList = await getCompanyListGroups(GET_COMPANY_LIST_GROUPS, token);
  //   console.log(getCompanyList?.data, "getCompanyListVIV");
  //   if (getCompanyList?.success) {
  //     setCompanyList(getCompanyList?.data);
  //   }
  // };

  // useEffect(() => {
  //   fetchCompanyListData();
  // }, []);

  const { data: getCompanyListData, isLoading } = useFetchCompanyListDataQuery({ token });

  useEffect(() => {
    if (getCompanyListData) {
      // console.log(getCompanyListData, "hellocompanyyy");
      setCompanyList(getCompanyListData?.data);
    }
  }, [getCompanyListData]);

  // toggling company checkbox
  const handleCompanyToggle = (companyId, checked) => {
    setViewOwnerDropDown(checked ? companyId : null);

    setFormData((prev) => {
      const prevCompany = Array.isArray(prev?.company) ? prev.company : [];
      const nextArr = checked
        ? [...prevCompany, { company_id: companyId, group_id: null, owner: null }]
        : prevCompany.filter((c) => c.company_id !== companyId);
      return { ...prev, company: nextArr };
    });
  };

  //changing either of the select under each company
  const handleCompanySelect = (companyId, key, value) => {
    setFormData((prev) => {
      const nextArr = prev.company.map((item) => (item.company_id === companyId ? { ...item, [key]: value } : item));
      return { ...prev, company: nextArr };
    });

    // console.log(formData, "helllosformmm");
  };

  useEffect(() => {
    const hasInvalid =
      !formData?.company?.length || formData?.company?.some((c) => c.owner === null || c.group_id === null);
    setIsCompanyValid(!hasInvalid);
  }, [formData?.company, setIsCompanyValid]);

  return (
    <CustomDrawer
      open={isPermissionOpen}
      onClose={() => setIsPermissionOpen(false)}
      subDrawer={subDrawer}
      headerText={formData?.assign_to === 1 ? "Admin" : "Member"}
      width={"30vw"}
    >
      {/* {console.log(company, "companyyyy")} */}
      <div className="bg-[#FFF] rounded-md p-1.5">
        <ToggleSwitch
          leftEle={"Modules"}
          rightEle={"Company Delegation"}
          className={"w-full text-[11px] text-nowrap"}
          onToggle={() => setIsModuleVisible((prev) => !prev)}
        />
      </div>
      <div className=" bg-white h-full w-full flex flex-col font-poppins rounded-md overflow-hidden no-scrollbar">
        {/* heading */}
        {false && (
          <div className="border-b border-[#BECBD3]">
            <div className="mx-3 flex items-center justify-between py-4 md:py-3  ">
              <h3 className="text-xl text-1D4469 font-500 font-poppins">
                {formData?.assign_to === 1 ? "Admin" : "Member"}
              </h3>
              {/* <button
              onClick={() => setIsPermissionOpen(false)}
              className="text-454545  hover:text-[#1D4469]  text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            >
              <img src={crossIcon} alt="Close" className="hover:bg-[#EBF2F6] w-5 h-5  hover:text-[#1D4469]" />
            </button> */}
            </div>
          </div>
        )}

        {/* body */}
        <LoaderWrapper isLoading={isLoading}>
          <div className="overflow-y-auto h-full thinscrollbar flex flex-col gap-2 px-3">
            {/* 1st Section - Module */}
            {isModuleVisible && (
              <div className="flex flex-col h-full py-2 ">
                <div className="py-2 sticky top-0 z-10 bg-white">
                  <MotionSearchBox
                    expanded={true}
                    isSearchActive={true}
                    searchText={groupSearchTerm}
                    setSearchText={setGroupSearchTerm}
                    placeholder="Search Group"
                  />
                </div>
                {/* {console.log(filteredGroups, "helllofilteredd")} */}
                <div className="flex flex-col h-full overflow-y-auto thinscrollbar">
                  {filteredGroups?.length ? (
                    filteredGroups.map((item) => (
                      <div key={item?.module_id} className="flex justify-between hover:bg-[#F3F5F7] px-1.5 py-2">
                        <Checkbox
                          label={
                            <HighlightedParagraph paragraph={item?.module_name || ""} searchTerm={groupSearchTerm} />
                          }
                          checked={item?.permission === 1}
                          // onChange={(e) =>{console.log(e?.target, "helllloeee")}}
                          disabled={true}
                        />
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 text-center py-2 text-sm">No results found</p>
                  )}
                </div>
              </div>
            )}

            {/* 2nd Section - Company Delegation */}
            {!isModuleVisible && (
              <div className="flex flex-col h-full py-2">
                <div className="py-2 sticky top-0 z-10 bg-white">
                  <MotionSearchBox
                    expanded={true}
                    isSearchActive={true}
                    searchText={companySearchTerm}
                    setSearchText={setCompanySearchTerm}
                    placeholder="Search Company"
                  />
                </div>
                <div className="flex flex-col h-full overflow-y-auto thinscrollbar gap-[1px]">
                  {sortedAndFilteredCompanyList?.length ? (
                    sortedAndFilteredCompanyList?.map((item, index) => (
                      <div
                        key={item.company_id}
                        className={`hover:bg-[#F3F5F7]  ${viewOwnerDropDown === item.company_id ? "bg-[#F3F5F7] border-b border-[#D2DAE1]" : ""} ${formData?.company?.find((element) => element.company_id === item.company_id) ? "bg-[#E8F2FF] " : ""}  rounded-md p-2`}
                      >
                        <div
                          className="flex justify-between items-center group"
                          onClick={() => {
                            setViewOwnerDropDown(viewOwnerDropDown === item.company_id ? null : item.company_id);
                          }}
                        >
                          <div className="flex gap-2">
                            <input
                              type="checkbox"
                              className="w-4 h-4 text-[#2999BC] border-[#D9D9D9] rounded-sm focus:ring-0 cursor-pointer"
                              checked={Boolean(
                                formData?.company?.find((element) => element.company_id === item.company_id)
                              )}
                              onChange={(e) => {
                                handleCheckboxChange(item.company_name);
                                handleCompanyToggle(item?.company_id, e.target.checked);
                              }}
                            />
                            <label className="cursor-pointer">
                              <HighlightedParagraph
                                paragraph={item?.company_name || ""}
                                searchTerm={companySearchTerm}
                              />
                            </label>
                          </div>
                          <DropDownArrow
                            fill={`#7A7D84`}
                            className={` ${viewOwnerDropDown !== item.company_id && "invisible"}  group-hover:visible  ${viewOwnerDropDown === item.company_id ? "rotate-180  visible" : "rotate-0"} transition-all duration-300 `}
                          />{" "}
                        </div>
                        {viewOwnerDropDown === item.company_id && (
                          <div className="py-2 rounded-md  ">
                            <div className="flex gap-1">
                              {/* owners basic select  - owner */}
                              <div className={`w-1/3`}>
                                <BasicSelect
                                  name="permission_level"
                                  size={"medium"}
                                  label=""
                                  onChange={(e) => handleCompanySelect(item.company_id, "owner", e.target.value)}
                                  options={AccessLevelArray.map((item) => ({
                                    label: item.label,
                                    value: item.value,
                                  }))}
                                  selectedOptions={formData?.company
                                    ?.filter((element) => element.company_id === item.company_id)
                                    ?.map((c) => ({
                                      label: AccessLevelArray.find((a) => a.value === c.owner)?.label,
                                      value: c.owner,
                                    }))}
                                  disabled={
                                    !formData?.company?.some((c) => c.company_id === item.company_id) &&
                                    "cursor-not-allowed"
                                  }
                                  isError={
                                    formData?.company?.some(
                                      (company) => company.company_id === item.company_id && company.owner === null
                                    )
                                      ? true
                                      : false
                                  }
                                />
                              </div>

                              {/* group basic select - group_id  */}
                              <div className="w-2/3">
                                {item?.groups && (
                                  <BasicSelect
                                    name="selected_group"
                                    size="medium"
                                    label="Group"
                                    onChange={(e) => handleCompanySelect(item.company_id, "group_id", e.target.value)}
                                    options={item?.groups?.map((element) => ({
                                      label: element.group_name,
                                      value: element.group_id,
                                    }))}
                                    selectedOptions={formData?.company
                                      ?.filter((c) => c.company_id === item.company_id)
                                      ?.map((c) => {
                                        const grp = item.groups.find((g) => g.group_id === c.group_id);
                                        return grp ? { label: grp.group_name, value: grp.group_id } : null;
                                      })}
                                    disabled={
                                      !formData?.company?.some((c) => c.company_id === item.company_id) &&
                                      "cursor-not-allowed"
                                    }
                                    isError={
                                      formData?.company?.some(
                                        (company) => company.company_id === item.company_id && company.group_id === null
                                      )
                                        ? true
                                        : false
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 text-center py-2 text-sm">No results found</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </LoaderWrapper>
      </div>
    </CustomDrawer>
  );
};

export default UserAccessDrawer;
